/**=========================================================
 * Module: tooltip.js
 * Tooltip Controller
 =========================================================*/
App.controller('TooltipController',
 ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService', '$filter', 'toaster', 'ngDialog',
 function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, $filter, toaster, ngDialog) {
   "use strict";

   $scope.fadeout = false;
   $scope.closingButtons = false;

   $scope.open = function(){
     if($rootScope.user.id){
      if(!$rootScope.hasTooltips) $rootScope.hasTooltips = {};
      $rootScope.hasTooltips[$scope.pid] = true;
      D.load('tooltip', $rootScope.user.id + '_' + $scope.pid+'.'+$scope.tid)
        .then(function(res){
          if(!res.id) {
            $scope.content = $filter('translate')('tooltips.' + $scope.tid.toUpperCase());
            $scope.fadeout = false;
            $scope.show = true;
            $rootScope.$broadcast('$tooltipOpen', { tid: $scope.tid, pid: $scope.pid });
          }
        }).catch(console.error);
    }
   }

   $scope.reopen = function(){
    $scope.content = $filter('translate')('tooltips.' + $scope.tid.toUpperCase());
    $scope.fadeout = false;
    $scope.show = true;
    $rootScope.$broadcast('$tooltipOpen', { tid: $scope.tid, pid: $scope.pid });
    D.remove('tooltip', $scope.pid+'.'+$scope.tid).catch(console.error)
  }
    
   $timeout(function(){
     if(!$scope.startClose){
      $scope.open();
     }
   }, parseInt($scope.wait)*1000);

   $scope.content = $filter('translate')('tooltips.' + $scope.tid.toUpperCase());

   $scope.closeTooltip = function(save, fromButton){
     if(false && fromButton && !$rootScope.hasAlreadyCloseATooltip){
      $scope.closingButtons = true;
      $rootScope.hasAlreadyCloseATooltip = true;
     } else {
      $scope.fadeout = true;
      $timeout(function(){$scope.show = false;}, 1250);
      $rootScope.$broadcast('$tooltipClose', { tid: $scope.tid, pid: $scope.pid });
      if(save){
        D.save('tooltip', {
          name: $scope.pid+'.'+$scope.tid
        }).catch(console.error);
      }
      }
   }

   $scope.closeAllTooltips = function(){
      $rootScope.$broadcast('$tooltipClose', { tid: null, pid: $scope.pid });
   }

   $scope.$on('$tooltipClose', function(event, args) {
     if(!args.tid && args.pid==$scope.pid){
       $scope.closeTooltip(true);
     }
     if(args.tid == $scope.tid && args.pid == $scope.pid && args.fromEvent){
       $scope.closeTooltip(false);
     }
  });

  $scope.$on('$tooltipOpenAll', function(event, args){
    if(args.pid==$scope.pid){
      $scope.reopen();
    }
  });

 }]);